import React from 'react'
import Creatable from 'react-select/creatable'
import Select, { Props } from 'react-select'

export default function CustomSelect({...customSelectProps}:Props) {
    return customSelectProps?.creatable ? <Creatable {...customSelectProps} /> : <Select {...customSelectProps} />
}
